import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function WhatsInside() {
  const revealRef = useScrollReveal();
  const items = ['6 capítulos de transformación progresiva e irreversible', 'Técnica de la Doble Rendija Emocional', 'Protocolo de Acceso al Estado Cero (4 pasos)', 'Meditación de Reescritura Cuántica — 4 fases de inmersión', 'Módulo especial: Activación de la Glándula Pineal', 'Checklists de conciencia atómica por módulo', 'Glosario cuántico del Observador Consciente', 'Frecuencias Solfeggio 528Hz y 963Hz incluidas', 'Mapa visual completo del proceso RENACER', 'FAQ completo del proceso de transformación'];
  return <section className="bg-brand-dark py-10 px-[5%]" data-id="element-217">
      <div ref={revealRef} className="max-w-7xl mx-auto reveal" data-id="element-218">
        <div className="text-center mb-[56px]" data-id="element-219">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-220">
            CONTENIDO
          </div>
          <h2 className="font-display italic text-[48px] text-brand-cream leading-tight mb-4" data-id="element-221">
            Todo lo que contiene el Protocolo
          </h2>
          <p className="font-body text-[16px] text-brand-muted" data-id="element-222">
            Más de 50 páginas de transformación real, aplicable desde la primera
            lectura.
          </p>
        </div>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-223">
          {items.map((item, i) => <div key={i} className="flex items-start gap-3 py-[14px] border-b border-white/[0.06]" data-id="element-224">
              <div className="text-brand-gold text-[16px] shrink-0 mt-[2px]" data-id="element-225">
                ✦
              </div>
              <div className="font-body text-[15px] text-brand-cream/80" data-id="element-226">
                {item}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}